module.exports = __webpack_public_path__ + "img/products_big_can_orange.4c5a4b23.png";